<template>
  <div>
    <InfoBox v-if="vmData.status != 'halted'">
      <div class="d-flex align-items-start justify-content-between">
        <span class="mr-3" style="max-width: 500px">{{
          $t('forms.vm.vmHaltedInfoMessage')
        }}</span>
        <ServerActionButton
          class="button danger"
          style="min-width: 120px"
          id="vm-stop"
          @click.native="runAction('shutdown', null, 'vm-stop')"
          :disabled="isDisableStop"
          :error="error"
        >
          <i class="fas fa-pause"></i>
          <span class="mr-1">{{ $t('detail.stop') }}</span>
        </ServerActionButton>
      </div>
    </InfoBox>

    <div>
      <!-- List Table -->
      <List
        :header="header"
        :data="data"
        :pagination="pagination"
        :loading="loading"
        @updatePage="updatePage"
      >
        <template v-slot:item.networkName="{ item }">
          {{ item.network && item.network.data ? item.network.data.name : '-' }}
        </template>
        <template v-slot:item.device_number="{ item }">
          {{ item.device_number }}
        </template>
        <template v-slot:item.action="{ item }">
          <b-dropdown
            v-if="vmData.status == 'halted'"
            class="actions-button nomaxh"
            variant="dark"
            :text="$t('global.actions')"
          >
            <b-dropdown-item @click.native="openRenameCard(item)">{{
              $t('servers.renameNetworkCard')
            }}</b-dropdown-item>
            <!-- <b-dropdown-item @click.native="openAttachToServerNetwork(item)">{{$t('servers.attachToAServer')}}</b-dropdown-item> -->
            <b-dropdown-item
              @click.native="openDetachFromServerNetwork(item)"
              >{{ $t('servers.detachFromServer') }}</b-dropdown-item
            >
            <!-- <b-dropdown-item @click.native="openChangeMacAddressPopupNetwork(item)">{{$t('servers.changeMacAddress')}}</b-dropdown-item> -->
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click.native="openAttachIPv4PopupNetwork(item)">{{
              $t('servers.attachIPv4')
            }}</b-dropdown-item>
            <b-dropdown-item @click.native="openDetachIPv4PopupNetwork(item)">{{
              $t('servers.detachIPv4')
            }}</b-dropdown-item>
            <b-dropdown-item
              @click.native="openAssignRandomIPv4PopupNetwork(item)"
              >{{ $t('servers.assignRandomIPv4') }}</b-dropdown-item
            >
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              class="dropdownAlertLabel"
              @click.native="openTerminatePopupNetwork(item)"
              >{{ $t('servers.terminate') }}</b-dropdown-item
            >
          </b-dropdown>
          <div v-else>-</div>
        </template>
      </List>

      <b-button
        :disabled="vmData.status != 'halted'"
        type="button"
        @click="createAttachNetworkCard()"
        variant="primary"
        class="px-10 mt-5"
        >{{ $t('servers.createAttachNetworkCard') }}</b-button
      >

      <!-- Create Popup -->
      <DetailModal
        :title="$t(dynamicOperationComponentTitle)"
        :show="showDetail"
        @confirm="confirmModal()"
        @closeDetail="closeDetail()"
        :resetForm="resetForm"
      >
        <component
          v-if="dynamicOperationComponent != ''"
          :is="dynamicOperationComponent"
          :confirmModal="confirmCreate"
          @resetDetailForm="resetDetailForm"
          :selectedId="selected.id"
          :selectedNetworkId="
            selected && selected.network && selected.network.data
              ? selected.network.data.id
              : ''
          "
        />
      </DetailModal>

      <DeleteOperation :url="deleteOperationUrl" @updateList="getList" />
    </div>
  </div>
</template>

<script>
// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'NetworkCards',
  data() {
    return {
      loading: false,
      vmData: '',
      header: [
        {
          text: 'global.name',
          value: 'name',
        },
        {
          text: 'servers.macAddress',
          value: 'mac_addr',
        },
        {
          text: 'servers.networkName',
          value: 'networkName',
        },
        {
          text: 'global.bandWidthMaxBW',
          value: 'bandwidth_limit',
        },
        {
          text: 'servers.deviceNumber',
          value: 'device_number',
        },
        { text: 'global.actions', value: 'action' },
      ],
      data: [],
      pagination: {},
      meta: {},
      deleteOperationUrl: '',
      dynamicOperationComponentTitle: '',
      dynamicOperationComponent: '',
      showDetail: false,
      confirmCreate: false,
      resetForm: false,
      selected: '',
      error: 'It is a long established fact that a reader will be.',
    }
  },
  props: {
    vmId: {
      type: String,
      default: '',
    },
  },
  computed: {
    getVmId() {
      return this.vmId ? this.vmId : this.$route.params.id
    },
  },
  created() {
    this.getVmDetail()
    this.getList()
  },
  methods: {
    //Vm detail:begin
    getVmDetail() {
      this.loading = true
      this.getVmDetailInfo().then((res) => {
        this.vmData = res.data
      })
    },
    getVmDetailInfo() {
      return new Promise((resolve, reject) => {
        ApiService.get(`iaas/virtual-machines/${this.getVmId}`)
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    //Vm detail:end
    getList() {
      this.loading = true

      const { current_page } = this.meta

      let $query = `iaas/virtual-network-cards?include=virtualMachine&virtualMachine=${
        this.getVmId
      }&position=id|desc&page=${current_page ? current_page : 1}`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    closeDetail() {
      this.showDetail = false
      this.dynamicOperationComponentTitle = ''
      this.dynamicOperationComponent = ''
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.$generateToast(this, 'success', this.$t('global.successful'))
        this.closeDetail()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
    openRenameCard(item) {
      this.selected = item
      this.dynamicOperationComponentTitle = 'servers.renameNetworkCard'
      this.dynamicOperationComponent = 'RenameNetworkCard'
      this.showDetail = true
    },
    openAttachToServerNetwork(item) {
      this.selected = item
      this.dynamicOperationComponentTitle = 'servers.attachToAServer'
      this.dynamicOperationComponent = 'AttachToAServer'
      this.showDetail = true
    },
    openDetachFromServerNetwork(item) {
      this.selected = item
      this.dynamicOperationComponentTitle = 'servers.detachFromServer'
      this.dynamicOperationComponent = 'DetachFromServer'
      this.showDetail = true
    },
    openChangeMacAddressPopupNetwork(item) {
      this.selected = item
      this.dynamicOperationComponentTitle = 'servers.changeMacAddress'
      this.dynamicOperationComponent = 'ChangeMacAddress'
      this.showDetail = true
    },
    openAttachIPv4PopupNetwork(item) {
      this.selected = item
      this.dynamicOperationComponentTitle = 'servers.attachIPv4'
      this.dynamicOperationComponent = 'AttachIPv4'
      this.showDetail = true
    },
    openDetachIPv4PopupNetwork(item) {
      this.selected = item
      this.dynamicOperationComponentTitle = 'servers.detachIPv4'
      this.dynamicOperationComponent = 'DetachIPv4'
      this.showDetail = true
    },
    openAssignRandomIPv4PopupNetwork(item) {
      this.selected = item
      this.dynamicOperationComponentTitle = 'servers.assignRandomIPv4'
      this.dynamicOperationComponent = 'AssignRandomIPv4'
      this.showDetail = true
    },
    openTerminatePopupNetwork(item) {
      this.deleteOperationUrl = `iaas/virtual-network-cards/${item.id}`
      this.$bvModal.show('modal-deleteOperation')
    },
    createAttachNetworkCard() {
      this.selectedId = ''
      this.dynamicOperationComponentTitle = 'servers.createAttachNetworkCard'
      this.dynamicOperationComponent = 'CreateAttachNetworkCard'
      this.showDetail = true
    },
    active() {
      this.enableButton = this.$refs['enable_button']
      this.$spinnerLoader.addSpinnerLoader(this.enableButton)

      setTimeout(() => {
        this.$generateToast(this, 'danger', 'Api Eklenecek')
        this.$spinnerLoader.removeSpinnerLoader(this.enableButton)
      }, 1000)
    },
    // Product catalog:end
    runAction(action, params, idName) {
      EventBus.$emit('clickVmStopButton', { action, params, idName })
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
  components: {
    RenameNetworkCard: () =>
      import(
        '@/components/compute/virtualMachines/networkCards/RenameNetworkCard'
      ),
    AttachToAServer: () =>
      import(
        '@/components/compute/virtualMachines/networkCards/AttachToAServer'
      ),
    DetachFromServer: () =>
      import(
        '@/components/compute/virtualMachines/networkCards/DetachFromServer'
      ),
    ChangeMacAddress: () =>
      import(
        '@/components/compute/virtualMachines/networkCards/ChangeMacAddress'
      ),
    AttachIPv4: () =>
      import('@/components/compute/virtualMachines/networkCards/AttachIPv4'),
    DetachIPv4: () =>
      import('@/components/compute/virtualMachines/networkCards/DetachIPv4'),
    AssignRandomIPv4: () =>
      import(
        '@/components/compute/virtualMachines/networkCards/AssignRandomIPv4'
      ),
    CreateAttachNetworkCard: () =>
      import(
        '@/components/compute/virtualMachines/networkCards/CreateAttachNetworkCard'
      ),
    ServerActionButton: () => import('@/components/buttons/ServerActionButton'),
  },
}
</script>
